import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState = {
  accessToken: null,
  requestingTokens: false,
  wsCredentials: {
    token: null,
    socketUrl: null,
  },
  profileDetails: {
    business_list: [],
    email: null,
    role: null,
    business_id: null,
    permissions: {},
    referral_code: "",
  },
  businessDetails: {
    business_name: null,
    is_subscribed: true,
    has_wallet: false,
    allow_access_to_customers_across_stores: false,
  },
  storeList: [],
  isCollapseSidebar: null,
};

export const profileDetailsSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileDetails: (state, action) => {
      state.profileDetails = action.payload;
    },
    setBusinessDetails: (state, action) => {
      state.businessDetails = action.payload;
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setRequestingTokens: (state, action) => {
      state.requestingTokens = action.payload;
    },
    setStoreList: (state, action) => {
      state.storeList = action.payload;
    },
    setIsCollapseSidebar: (state, action) => {
      state.isCollapseSidebar = action.payload;
    },
    setWsCredentials: (state, action) => {
      state.wsCredentials = action.payload;
    },
  },
});

export const {
  setProfileDetails,
  setBusinessDetails,
  setAccessToken,
  setRequestingTokens,
  setStoreList,
  setIsCollapseSidebar,
  setWsCredentials,
} = profileDetailsSlice.actions;
